const maintenanceEn = {
    scheduled: require('../../lang/en/maintenance/Scheduled').default,
    objectMaintenance: require('../../lang/en/maintenance/ObjectMaintenance').default,
    feedback: require('../../lang/en/maintenance/Feedback').default,
};

export default maintenanceEn;